import { EventClass, EventType } from "../../../../_game/config/Events";
import { MENU_POPUPS } from "../../../../_game/config/Game";
import {
  __App,
  __ErrorManager,
  __EventDispatcher,
  __Lang,
  __ProxiProvider,
  __UrlParams,
} from "../../../core";
import { PopupInterface } from "./Popup";

export const ModalWindowOptions = new Map<MENU_POPUPS, PopupInterface>();

const onReload = () => {
  let _errCode =
    typeof __ErrorManager.props.arrErrors[0] !== "undefined"
      ? __ErrorManager.props.arrErrors[0].code
      : 0;
  let redirectFunction: any;
  let disconnectUrl = __UrlParams.props.disconnectredirect;

  if (_errCode === 13) {
    if (
      parseInt(__UrlParams.props.siteID) === 30 &&
      parseInt(__UrlParams.props.brandID) === 1
    ) {
      redirectFunction = () => {
        //@ts-ignore
        window.top.location.href =
          disconnectUrl !== ""
            ? disconnectUrl
            : "https://www.lottogo.com/en?launch=4551";
      };
    } else if (
      parseInt(__UrlParams.props.siteID) === 30 &&
      parseInt(__UrlParams.props.brandID) === 2
    ) {
      redirectFunction = () => {
        //@ts-ignore
        window.top.location.href =
          disconnectUrl !== ""
            ? disconnectUrl
            : "https://www.lottogo.com.au/en?launch=4551";
      };
    } else {
      redirectFunction = () => {
        //@ts-ignore
        window.top.location.href = __UrlParams.props.lobbyURL;
      };
    }
  } else {
    redirectFunction = __App.reloadApp;
  }

  return {
    text: __Lang.translate("n:play.TEXT_RELOAD") ?? "RELOAD",
    onClick: () => {
      __ProxiProvider.gameReload();
      redirectFunction();
    },
  };
};

const onOk = () => {
  return {
    text: __Lang.translate("n:play.TEXT_OK") ?? "OK",
    onClick: () => {},
  };
};

const onClose = () => {
  return {
    text: __Lang.translate("n:play.TEXT_CLOSE") ?? "CLOSE",
    onClick: () => {
      __EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.CLEAR_POPUP);
    },
  };
};

const onCashier = () => {
  return {
    text: __Lang.translate("n:DEPOSIT_BTN") ?? "CASHIER",
    onClick: () => {
      __ProxiProvider.visitCashier();
    },
    showCondition: __UrlParams.props.depositURL || __UrlParams.props.cashierURL,
  };
};

const onHome = () => {
  return {
    text: __Lang.translate("n:LOBBY_BTN") ?? "HOME",
    onClick: () => {
      __ProxiProvider.visitLobby();
    },
    showCondition: __UrlParams.props.lobbyURL,
  };
};

const onReloadError = () => {
  let _errCode =
    typeof __ErrorManager.props.arrErrors[0] !== "undefined"
      ? __ErrorManager.props.arrErrors[0].code
      : 0;
  let redirectFunction: any;
  let disconnectUrl = __UrlParams.props.disconnectredirect;

  if (_errCode === 13) {
    if (
      parseInt(__UrlParams.props.siteID) === 30 &&
      parseInt(__UrlParams.props.brandID) === 1
    ) {
      redirectFunction = () => {
        //@ts-ignore
        window.top.location.href =
          disconnectUrl !== ""
            ? disconnectUrl
            : "https://www.lottogo.com/en?launch=4551";
      };
    } else if (
      parseInt(__UrlParams.props.siteID) === 30 &&
      parseInt(__UrlParams.props.brandID) === 2
    ) {
      redirectFunction = () => {
        //@ts-ignore
        window.top.location.href =
          disconnectUrl !== ""
            ? disconnectUrl
            : "https://www.lottogo.com.au/en?launch=4551";
      };
    } else {
      redirectFunction = () => {
        //@ts-ignore
        window.top.location.href = __UrlParams.props.lobbyURL;
      };
    }
  } else {
    redirectFunction = __App.reloadApp;
  }

  //@ts-ignore
  return {
    text: __Lang.translate("n:play.TEXT_RELOAD") ?? "RELOAD",
    onClick: () => {
      // __ErrorManager.popShownError();
      // __ProxiProvider.gameReload();
      redirectFunction();
    },
  };
};

const onContinueWarning = () => {
  return {
    text: __Lang.translate("n:play.TEXT_CONTINUE") ?? "CONTINUE",
    onClick: () => __ErrorManager.popShownError(),
  };
};

export const modalFunction = {
  onReload,
  onClose,
  onCashier,
  onHome,
  onOk,
  onReloadError,
  onContinueWarning,
};

export const modalWindowOptionsInit = () => {
  /** Popup Reload */
  ModalWindowOptions.set(MENU_POPUPS.POPUP_RELOAD, {
    title: __Lang.translate("n:TEXT_GENERIC_ERROR_TITLE"),
    content: __Lang.translate("n:TEXT_GENERIC_ERROR_TEXT"),
    buttons: [modalFunction.onReload()],
  });
  /** Popup Insuficient Founds Buttons */
  const insuficientFoundsButtons = [modalFunction.onClose()];
  if (__UrlParams.props.cashierURL)
    insuficientFoundsButtons.push(modalFunction.onCashier());
  // if (__UrlParams.props.lobbyURL) insuficientFoundsButtons.push(modalFunction.onHome());

  ModalWindowOptions.set(MENU_POPUPS.INSUFFICIENT_FUNDS_WINDOW, {
    title: __Lang.translate("n:TEXT_INSUFFICIENT_FOUNDS_TITLE"),
    content: __Lang.translate("n:TEXT_INSUFFICIENT_FOUNDS_LABEL"),
    buttons: insuficientFoundsButtons,
  });

  ModalWindowOptions.set(MENU_POPUPS.POPUP_INSURANCE, {
    title: __Lang.translate("n:TEXT_GENERIC_ERROR_TITLE"),
    content: __Lang.translate("n:TEXT_SUBSCRIPTION_BET_FAILURE_GENERIC"),
    buttons: [modalFunction.onReload()],
  });

  ModalWindowOptions.set(MENU_POPUPS.ZERO_FUNDS_WINDOW, {
    title: __Lang.translate("n:TEXT_INSUFFICIENT_FOUNDS_TITLE"),
    content: __Lang.translate("n:TEXT_ZERO_FOUNDS_LABEL"),
    buttons: insuficientFoundsButtons,
  });

  ModalWindowOptions.set(MENU_POPUPS.POPUP_OK, {
    title: "",
    content: "",
    buttons: [modalFunction.onOk()],
  });

  ModalWindowOptions.set(MENU_POPUPS.ERROR_POPUP_CRITICAL, {
    title: "",
    content: "",
    buttons: [modalFunction.onReloadError()],
  });

  ModalWindowOptions.set(MENU_POPUPS.ERROR_POPUP_CRITICAL_WS_DISCONNECT, {
    title: "Error!",
    content: "Websocket Disconnect!",
    buttons: [modalFunction.onReloadError()],
  });

  ModalWindowOptions.set(MENU_POPUPS.ERROR_POPUP_CRITICAL_NOINPUT, {
    title: "",
    content: "",
    buttons: [],
  });

  ModalWindowOptions.set(MENU_POPUPS.ERROR_POPUP_WARNING, {
    title: "",
    content: "",
    buttons: [modalFunction.onContinueWarning()],
  });

  ModalWindowOptions.set(MENU_POPUPS.POPUP_BET, {
    title: "",
    content: "",
    buttons: [],
  });

  ModalWindowOptions.set(MENU_POPUPS.POPUP_SUCCESS, {
    title: __Lang.translate("n:play.success"),
    content: __Lang.translate("n:play.your_bets_are_placed_successfully"),
    buttons: [],
    timer: 1500,
  });

  ModalWindowOptions.set(MENU_POPUPS.POPUP_RESULTS, {
    title: "",
    content: "",
  });
};
